import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalCloseButton,
  ModalHeader,
  ModalOverlay,
  Flex,
  Box,
  useDisclosure,
  useToast,
  Image,
  Text,
} from '@chakra-ui/react'
import { Button } from '../../../../components/Button'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { useMutation, useQuery } from 'react-query'
import { zodResolver } from '@hookform/resolvers/zod'
import { Input } from '../../../../components/Form/Input'
import { DragAndDrop } from '../../../../components/DragAndDrop'
import { api } from '../../../../services/api'

async function uploadCompreGanhe(data) {
  const res = await api.post('/site/v2/orcamento-crm/enviar-imagens-ilustracao-crm', data)

  return res.data
}

async function listarBases() {
  const res = await api.get('/site/v2/fluxo-layout/listar-base-compre-ganhe')

  return res.data
}

const schema = z.object({
  arquivo: z.any(),
  numero_pedido: z.string(),
  numero_nota: z.string(),
  nome_ilustracao: z.string().nonempty('Nome da ilustração é obrigatório.'),
  modelo_arte: z.string().nonempty('Modelo da arte é obrigatório.'),
  link_base: z.string().nonempty('Link base é obrigatório.'),
})

export const EnviarCompreGanhe = ({ ...props }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { register, handleSubmit, control, formState, setValue, watch } = useForm({
    resolver: zodResolver(schema),
  })

  const modeloArte = watch('modelo_arte')

  const toast = useToast({
    position: 'top-right',
    duration: 5000,
    isClosable: true,
  })

  console.log(formState?.errors)

  const { data, isLoading: listarBasesLoading } = useQuery({
    queryKey: 'bases-ilsutracoes-gerar-pedido',
    queryFn: listarBases,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 30,
    enabled: isOpen,
  })

  console.log(data)

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: uploadCompreGanhe,
    onSuccess: () => {
      toast({
        title: 'Compre Ganhe enviado com sucesso!',
        status: 'success',
      })
      onClose()
    },
    onError: (error) => {
      toast({
        title: 'Erro ao enviar Compre Ganhe',
        description: error.response.data.erros,
        status: 'error',
      })
    },
  })

  async function onSubmit(data) {
    const formData = new FormData()
    formData.append('arquivo', data.arquivo)
    formData.append('numero_pedido', data.numero_pedido)
    formData.append('numero_nota', data.numero_nota)
    formData.append('nome_ilustracao', data.nome_ilustracao)
    formData.append('codigo_produto', props.itens[props.itens?.length - 1]?.codigo_produto)
    formData.append('nome', data.nome_ilustracao)
    formData.append('codigo_vendedor', props.consultor.codigo_vendedor)
    formData.append('sequencia', props.itens[props.itens?.length - 1]?.sequencia)
    formData.append('nome_produto', props.itens[props.itens?.length - 1]?.nome_produto)
    formData.append('codigo_parceiro', props.dados_faturamento?.codigo_parceiro)
    formData.append('prazo_producao', props.itens[props.itens?.length - 1]?.prazo)
    formData.append('nome_vendedor', props.consultor.nome)
    formData.append('link_base', data.link_base)
    formData.append('modelo_arte', data.modelo_arte)

    await mutateAsync(formData)
  }

  function handleBaseIlustracao(id, link) {
    setValue('modelo_arte', id)
    setValue('link_base', link)
  }

  return (
    <>
      <Button pointerEvents="auto" ml="auto" onClick={onOpen}>
        Enviar Compre Ganhe
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} size="3xl">
        <ModalOverlay />
        <ModalContent as="form" onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader>Enviar Compre e Ganhe</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex flexWrap="wrap" gap={5}>
              {data?.map((item, index) => (
                <Flex key={index} flexDir="column" alignItems="center" gap={2} borderRadius="md" boxShadow="md" p={2}>
                  <Text size="sm" color="gray.700" fontWeight="semibold">
                    Arte - {item.modelo_arte}
                  </Text>
                  <Image src={item.link_base} width="150px" height="200px" objectFit="contain" />
                  <Button
                    bgColor={modeloArte === item.modelo_arte ? 'green.500' : '#FFA200'}
                    onClick={() => handleBaseIlustracao(item.modelo_arte, item.link_base)}
                  >
                    {item.modelo_arte === modeloArte ? 'Selecionado' : 'Selecionar'}
                  </Button>
                </Flex>
              ))}
            </Flex>

            {formState.errors.modelo_arte && (
              <Box color="red.500" fontSize="sm">
                {formState.errors.modelo_arte.message}
              </Box>
            )}

            <Flex flexDir="column" gap={2} mt={4}>
              <Input label="Nome da Ilustração" {...register('nome_ilustracao')} error={formState.errors.nome_ilustracao} />
              {formState.errors.nome_ilustracao && (
                <Box color="red.500" fontSize="sm">
                  {formState.errors.nome_ilustracao.message}
                </Box>
              )}

              <input type="hidden" {...register('numero_pedido')} value={props.dados_pedido?.numero_pedido} />
              <input type="hidden" {...register('numero_nota')} value={props.dados_pedido?.numero_nota} />

              <DragAndDrop control={control} name="arquivo" />

              {formState.errors.arquivo && (
                <Box color="red.500" fontSize="sm">
                  {formState.errors.arquivo.message}
                </Box>
              )}
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button type="submit" colorScheme="blue" mr={3} isLoading={isLoading}>
              Confirmar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
